import { memo } from 'react';

import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { VisitAndAppointmentPrescriptionOnlyView } from '@dreryk/egabinet-visit-frontend-api';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { prescriptionVisitsTranslationKeys } from '../../translations';

import {
   usePrescriptionVisitsDataConfiguration,
   usePrescriptionVisitsTableColumns,
} from './PrescriptionVisitsTable.hooks';
import { PrescriptionVisitsTableDataAccessor } from './PrescriptionVisitsTableDataAccessor';

type PrescriptionVisitsTableProps = {
   readonly currentDoctor: DoctorSimple | null;
   readonly doctors: DoctorSimple[];
   readonly onlinePaymentsIntegrationExists: boolean;
};

const PrescriptionVisitsTable = (props: PrescriptionVisitsTableProps): JSX.Element => {
   const dataConfiguration = usePrescriptionVisitsDataConfiguration(props.currentDoctor, props.doctors);
   const columns = usePrescriptionVisitsTableColumns(dataConfiguration.refetch, props.onlinePaymentsIntegrationExists);

   return (
      <Table<VisitAndAppointmentPrescriptionOnlyView>
         testId={'prescriptionVisits'}
         keyExtractor={(bean) => bean.appointmentId.asNumber()}
         columns={columns}
         dataConfiguration={dataConfiguration}
         dataAccessor={PrescriptionVisitsTableDataAccessor}
         pageSize={50}
         placeholder={
            <EmptyStatePlaceholder
               heading={prescriptionVisitsTranslationKeys.noVisits.noVisits}
               subheading={prescriptionVisitsTranslationKeys.noVisits.noResults}
               testId={'noPrescriptionVisits'}
            />
         }
      />
   );
};

const MemoizedPrescriptionVisitsTable = memo(PrescriptionVisitsTable);

export { MemoizedPrescriptionVisitsTable as PrescriptionVisitsTable };
